import { render, staticRenderFns } from "./MobileQuestion.vue?vue&type=template&id=13d48595"
import script from "./MobileQuestion.vue?vue&type=script&lang=ts"
export * from "./MobileQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports